<nav backgroundColor="accent" color="warn" mat-align-tabs="center" mat-tab-nav-bar [tabPanel]="tabPanel"
  mat-stretch-tabs="false">
  <a (click)="activeLink = '/setup/resourcing/resources'"
    [active]="activeLink.startsWith('/setup/resourcing/resources')" [routerLink]="'/setup/resourcing/resources'"
    mat-tab-link>Resources</a>

  <a (click)="activeLink = '/setup/resourcing/rosters'" [active]="activeLink.startsWith('/setup/resourcing/rosters')"
    [routerLink]="'/setup/resourcing/rosters'" mat-tab-link>Rosters</a>

  <a (click)="activeLink = '/setup/resourcing/teams'" [active]="activeLink === '/setup/resourcing/teams'"
    [routerLink]="'/setup/resourcing/teams'" mat-tab-link>Teams</a>

  <a (click)="activeLink = '/setup/resourcing/zones'" [active]="activeLink === '/setup/resourcing/zones'"
    [routerLink]="'/setup/resourcing/zones'" mat-tab-link>Zones</a>
  <a (click)="activeLink = '/setup/resourcing/planners'" [active]="activeLink === '/setup/resourcing/planners'"
    [routerLink]="'/setup/resourcing/planners'" mat-tab-link>Planners</a>

  @if (!hideResourceGroups) {
  <a (click)="activeLink = '/setup/resourcing/groups'" [active]="activeLink.startsWith('/setup/resourcing/groups')"
    [routerLink]="'/setup/resourcing/groups'" mat-tab-link>Groups</a>
  }

  <a (click)="activeLink = '/setup/resourcing/mapping-patterns'"
    [active]="activeLink.startsWith('/setup/resourcing/mapping-patterns')"
    [routerLink]="'/setup/resourcing/mapping-patterns'" mat-tab-link>Mapping Patterns</a>
</nav>
<mat-tab-nav-panel #tabPanel>
  <router-outlet></router-outlet>
</mat-tab-nav-panel>